import axios from "@/config/axios-wrapper";

export const getJobseekerMeetingByJobId = async (userId: string) => {
  const response = await axios.get(`/jobseekers/${userId}/meetings`);

  return response.data;
};
